// Бренд сборки: DOSCAR (по умолчанию) или Horizon (Rox, JetQ).
//
// Один код обслуживает три брокера. Раньше палитру и логотип держали в
// отдельных ветках и правили цвета руками в полусотне файлов — ветки
// разъезжались, и JetQ застрял на коде от июля. Теперь бренд выбирается
// при сборке переменной REACT_APP_BRAND (в .env сервера), а цвета живут в
// CSS-переменных (theme.css) и в палитре ниже.
//
//   REACT_APP_BRAND=          → doscar (как было)
//   REACT_APP_BRAND=horizon   → синяя палитра и логотип Horizon

export const BRANDS = {
  doscar: {
    title: 'Doscar',
    // Тёмный фон сайдбара и заголовков.
    dark: '#494136',
    // Основной акцент: кнопки, иконки, рамки.
    primary: '#D9BC92',
    // Подсветка строк таблиц.
    row: '#F8F0E4',
  },
  horizon: {
    title: 'Horizon',
    dark: '#404A5F',
    primary: '#B45436',
    row: '#F4F4F4',
  },
};

export const resolveBrand = (value) => {
  const key = String(value || '').trim().toLowerCase();
  return BRANDS[key] ? key : 'doscar';
};

export const BRAND = resolveBrand(process.env.REACT_APP_BRAND);
export const brand = BRANDS[BRAND];

/** Применить бренд к документу: атрибут для CSS-переменных и заголовок вкладки. */
export const applyBrand = (doc = document) => {
  doc.documentElement.dataset.brand = BRAND;
  doc.title = brand.title;
};
